var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPokerSeats8(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 3,
    width: 14,
    height: 10,
    rx: 5,
    fill: "#8FC1EA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 4.293c.423 0 .8.076 1.128.23.329.152.586.375.771.668.19.29.284.647.284 1.07 0 .355-.095.67-.284.947a1.89 1.89 0 01-.723.629l.025.01c.355.167.633.396.835.69.205.292.308.634.308 1.025 0 .442-.103.815-.308 1.118a1.927 1.927 0 01-.84.688c-.351.153-.748.23-1.191.23-.443 0-.842-.077-1.196-.23a1.927 1.927 0 01-.84-.688c-.205-.303-.308-.676-.308-1.118a1.791 1.791 0 01.654-1.416c.15-.125.318-.228.503-.312a1.925 1.925 0 01-.722-.626 1.661 1.661 0 01-.279-.947c0-.423.093-.78.279-1.07a1.81 1.81 0 01.776-.669c.329-.153.705-.229 1.128-.229zm-.005 4.023c-.234 0-.438.05-.61.147a1.036 1.036 0 00-.406.415 1.321 1.321 0 00-.141.625c0 .24.047.45.141.625a.95.95 0 00.406.395c.176.092.382.137.62.137a1.3 1.3 0 00.615-.137.956.956 0 00.4-.395c.095-.176.142-.384.142-.625 0-.238-.049-.446-.146-.625a1.028 1.028 0 00-.41-.415 1.236 1.236 0 00-.61-.147zM8 5.226c-.205 0-.382.044-.532.131a.888.888 0 00-.347.372c-.081.159-.122.35-.122.57 0 .219.04.41.122.572a.92.92 0 00.347.376c.153.091.332.137.537.137.205 0 .382-.046.532-.137a.92.92 0 00.347-.376c.081-.163.122-.353.122-.571a1.17 1.17 0 00-.127-.557.914.914 0 00-.347-.38A1.004 1.004 0 008 5.225z",
    fill: "#000"
  })));
}
SvgPokerSeats8.displayName = 'PokerSeats8';
export default SvgPokerSeats8;